const styles = (theme) => ({
  toolBar: {
    minHeight: 100,
    padding: 15,
    paddingBottom: 40,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    [theme.breakpoints.down("md")]: {
      fontSize: "2rem",
    },
  },
  content: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginBottom: 0,
  },
  textField: {
    width: "90%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginTop: 15,
      marginBottom: 15,
    },
  },
  inputStyle: {
    [theme.breakpoints.down("md")]: {
      fontSize: "1.5rem",
    },
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
    [theme.breakpoints.down("md")]: {
      fontSize: "2.2rem",
    },
  },
  listContent: {
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column-reverse",
    },
  },
  infoBox: {
    paddingLeft: 30,
    [theme.breakpoints.down("md")]: {
      paddingTop: 0,
      paddingLeft: 10,
    },
  },
  tableTitle: {
    fontSize: "2.7rem",
  },
  tableText: {
    color: "black",
    fontSize: "2.2rem!important",
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
});

export default styles;
